<mat-card>
  <mat-card-title>LicenceTypes</mat-card-title>
  <table mat-table [dataSource]="licenceTypes" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let element">{{ element.description }}</td>
    </ng-container>
    <ng-container matColumnDef="priceHuf">
      <th mat-header-cell *matHeaderCellDef>Price (HUF)</th>
      <td mat-cell *matCellDef="let element">
        {{ element.priceHuf | currency : 'Ft ' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="priceEur">
      <th mat-header-cell *matHeaderCellDef>Price (EUR)</th>
      <td mat-cell *matCellDef="let element">
        {{ element.priceEur | currency : '€ ' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-card>
